import { IArticleBase } from '@bridebook/web/app-shared/lib/articles/types';

export const ArticleBase: IArticleBase = {
  ID: 0,
  title: '',
  featured_image: null,
  slug: '',
  terms: null,
};
